module.exports = __webpack_public_path__ + "img/Candella_2_small.65bcd0a5.jpg";